export default __webpack_public_path__ + "static/media/ValuesIllustrationPlaceholder.6f48cc6c.webp";